import Rollbar from 'rollbar';

import ROLLBAR_CONFIG from './config';

// Rollbar Level Constants
export const LOG_LEVELS = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  DEBUG: 'debug',
};

export const updateRollbarAnonymousId = anonymousId => {
  if (window.Rollbar && window.Rollbar.configure) {
    window.Rollbar.configure({
      payload: {
        person: {
          id: anonymousId,
        },
      },
    });
  }
};

export const initRollbarSdk = () => {
  window.Rollbar = new Rollbar(ROLLBAR_CONFIG);
};

/**
 * Initiates a rollbar request to create a new log
 * @param {Object} log
 */
export const rollbarHelper = ({ level, message, info }) => {
  const logLevel = level || LOG_LEVELS.ERROR;

  try {
    if (window.Rollbar) {
      const windowRollbar = window.Rollbar;

      switch (logLevel) {
        case LOG_LEVELS.ERROR:
          windowRollbar.error(message, info);
          break;
        case LOG_LEVELS.WARNING:
          windowRollbar.warning(message, info);
          break;
        case LOG_LEVELS.INFO:
          windowRollbar.info(message, info);
          break;
        case LOG_LEVELS.DEBUG:
          windowRollbar.debug(message, info);
          break;
        default:
          // eslint-disable-next-line no-console
          console.warn('Invalid Rollbar Log Level', message, info);
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(err);
  }
};

export default rollbarHelper;
